module.exports = __webpack_public_path__ + "static/media/howitworks_arrow.e51c3a10.svg";